module.exports = __webpack_public_path__ + "img/basement.be5030ca.webp";